"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRGBComponents = getRGBComponents;
exports.idealTextColor = idealTextColor;

function getRGBComponents(color) {
  var r = color.substring(1, 3);
  var g = color.substring(3, 5);
  var b = color.substring(5, 7);
  return {
    r: parseInt(r, 16),
    g: parseInt(g, 16),
    b: parseInt(b, 16)
  };
}

function idealTextColor(bgColor) {
  var nThreshold = 105;
  var components = getRGBComponents(bgColor);
  var bgDelta = components.r * 0.299 + components.g * 0.587 + components.b * 0.114;
  return 255 - bgDelta < nThreshold ? '#000000' : '#ffffff';
}